import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardArray } from "@msuite/utils/array";
import type { GetOrganizationAbsencesQuerySchema } from "@msuite/utils/schemas";
import { client } from "@/hono";

export function useAbsences(
	query?: GetOrganizationAbsencesQuerySchema,
	options?: { enabled?: boolean },
) {
	/** Query */
	const _query = useQuery({
		queryKey: ["absences", "inbox", JSON.stringify(query)],
		queryFn: async () => {
			const response = await client.organizations.absences.$get({
				query: query ?? {},
			});
			const data = await responseHandler(response);
			return data;
		},
		enabled: options?.enabled,
	});

	/** Return */
	return {
		..._query,
		absences: guardArray(_query.data?.absences),
		grouped: guardArray(_query.data?.grouped),
	};
}
